module.exports = __webpack_public_path__ + "img/blog-single.e5719b87.jpg";